import React from 'react';
import CustomTd from '../shared/table/CustomTd';
import PropTypes from 'prop-types';
import SaveCancelButton from '../shared/buttons/SaveCancelButton';
import SelectList from '../shared/inputs/SelectList';
import FormControl from '../shared/inputs/FormControl';
import useForm from '../../utilities/useForm';

const ApiTokenEditor = ({
    cancelEdit,
    disabled,
    fetchData,
    getUrl,
    item: initialItem,
    postUrl
}) => {
    const { item, ...form } = useForm(initialItem.id === 0 ? null : getUrl, postUrl, { item: initialItem });

    const submitForm = () => {
        form.submitData(() => {
            cancelEdit();
            fetchData();
        });
    }

    return (
        <tr>
            <CustomTd>
                <div style={{ height: '1.9em' }}>
                    <FormControl
                        name='name'
                        defaultValue={item ? item.name : ''}
                        onChange={form.formChange}
                        validationError={item ? item.name_error : ''}
                    />
                </div>
            </CustomTd>
            <CustomTd>
                <SelectList
                    name={'franchiseId'}
                    value={item ? item.franchiseId : 0}
                    validationError={item ? item.franchiseId_error : ''}
                    lookupType={'Franchise'}
                    onChange={form.formChange} />
            </CustomTd>
            <CustomTd>
                <SelectList
                    name={'appUserId'}
                    filter={{ "franchiseId": item.franchiseId }}
                    value={item ? item.appUserId : 0}
                    validationError={item ? item.appUserId_error : ''}
                    lookupType={'AppUser'}
                    onChange={form.formChange} />
            </CustomTd>

            <CustomTd content={item.token} />

            <CustomTd width="98px">
                <SaveCancelButton
                    showText={false}
                    saveItem={submitForm}
                    cancelEdit={cancelEdit}
                    disabled={disabled}
                />
            </CustomTd>
        </tr>
    );
}

ApiTokenEditor.propTypes = {
    cancelEdit: PropTypes.func,
    fetchData: PropTypes.func,
    getUrl: PropTypes.string.isRequired,
    postUrl: PropTypes.string.isRequired
};

export default ApiTokenEditor;